import { Routes } from '@angular/router';
import { userGuard } from '@core/guards';
import { PageTitleEnum } from '@shared/enums';

export const dashboardRoutes: Routes = [
    {
        path: '',
        loadComponent: () => import('./dashboard-layout.component').then(mod => mod.DashboardLayoutComponent),
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./dashboard-page/dashboard-page.component').then(mod => mod.DashboardPageComponent),
                canActivate: [userGuard],
                title: PageTitleEnum.DASHBOARD,
            },
            {
                path: 'faq',
                loadComponent: () =>
                    import('./dashboard-faq/dashboard-faq.component').then(mod => mod.DashboardFaqComponent),
                canActivate: [userGuard],
                title: PageTitleEnum.DASHBOARD_FAQ,
            },
        ],
    },
];
